<app-mb-card class="info-card">
  <header>
    <h3>Editar imagen {{ size }}</h3>
  </header>
  <footer [formGroup]="updateImageForm">
    @if (company) {
      <div>
        <img [src]="company['image' + size]" alt="">
        <input #uploadInput type="file" style="display: none;" (change)="uploadInputChanged($event)">
        <app-mb-button (click)="clickUploadButton()">
          <i class="fas fa-cloud-upload-alt" style="margin: 0 .5rem;"></i>Cambiar imagen</app-mb-button>
          <app-mb-field [title]="'Actualizar todos los tamaños al actualizar esta imagen'" inline>
            <input type="checkbox" formControlName="updateAllSizes" autocomplete="new-password">
          </app-mb-field>
        </div>
      }
    </footer>
  </app-mb-card>